import React from "react";
import { MenuItem, Select } from "@mui/material";
import { useSelector } from "react-redux";
import { GlobalApplicationState } from "globalApplicationState";
import "../styles/languageSelect.sass";

interface ILanguageSelectProps {
    currLcid: string;
    onChangeLcid: (lcid: string) => void;
}

const LanguageSelect: React.FC<ILanguageSelectProps> = ({
    currLcid,
    onChangeLcid
}) => {
    const lcidMapping = useSelector((state: GlobalApplicationState) => state.resources.lcidMappings);
    const allTenantTCs = useSelector((state: GlobalApplicationState) => state.settings.tenantSettings.translatedContent);
    const defaultTenantLcid = useSelector((state: GlobalApplicationState) => state.settings.tenantSettings.defaultLCID);

    const allTenantLcids = Object.keys(allTenantTCs);
    const allMappedTenantLcids = Array
        .from(allTenantLcids)
        .filter(lcid => lcidMapping[lcid])
        .map(lcid => ({ mapping: lcidMapping[lcid], lcid }))
        .sort((a, b) => a.mapping.language.localeCompare(b.mapping.language));

    return <Select
        variant="outlined"
        value={currLcid}
        onChange={e => onChangeLcid(e.target.value)}
        size="small"
        sx={{ width: "100%"}}
        renderValue={val => lcidMapping[val].language}
        MenuProps={{ sx: { maxHeight: "30vh" }}}
    >
        {
            allMappedTenantLcids.map(t =>
                <MenuItem value={t.lcid} key={t.lcid}>
                    {
                        defaultTenantLcid == t.lcid
                            ? <div className="default-language-label-container">
                                {t.mapping.language}
                                <span className="default-language-indicator-label"><i>Default</i></span>
                            </div>
                            : t.mapping.language
                    }
                </MenuItem>
            )
        }
    </Select>;
};

export default LanguageSelect;
